__webpack_require__.p = "/assets/turbo/60feea67/universalat/_next/";